import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';

import * as MaterialStepper from 'material-ui/Stepper';
const { Stepper, Step, StepLabel } = MaterialStepper;

import styled from 'styled-components';

const StepperWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  background: ${props => props.theme.color.white};
`;

const StepperContainer = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

const ContentWrapper = styled.section`
  position: relative;
  padding-top: ${props => (props.showStepper ? 72 : 0)}px;
`;

class CreateQuote extends Component {
  render() {
    const { step } = this.props;
    const activeStepIndex = step - 1;
    const showStepper = Boolean(step !== 0);

    return (
      <section>
        {showStepper &&
          <StepperWrapper>
            <StepperContainer>
              <Stepper activeStep={activeStepIndex}>
                <Step><StepLabel>Vehicle</StepLabel></Step>
                <Step><StepLabel>Lease</StepLabel></Step>
                <Step><StepLabel>Delivery</StepLabel></Step>
              </Stepper>
            </StepperContainer>
          </StepperWrapper>}
        <ContentWrapper showStepper={showStepper}>
          {this.props.children}
        </ContentWrapper>
      </section>
    );
  }
}

CreateQuote.propTypes = {
  step: PropTypes.number.isRequired,
  actions: PropTypes.object.isRequired,
  children: PropTypes.node
};

const mapStateToProps = state => {
  const { step } = state.corporateQuote.create;

  return { step };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateQuote);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/CreateQuote.js